var _g, _path, _path2, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeedlingTrees(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1891,
    height: 516,
    viewBox: "0 0 1891 516",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1775.32 411.37C1775.32 467.55 1761.46 485.12 1744.35 485.12C1727.24 485.12 1713.38 467.54 1713.38 411.37C1713.38 355.2 1727.24 281.69 1744.35 281.69C1761.46 281.69 1775.32 355.19 1775.32 411.37V411.37Z",
    fill: "#091731",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1744.35 485.13V512.56",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1511.31 462.14C1511.31 399.28 1470.32 394.27 1470.32 394.27",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1511.31 479.53V456.8",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1511.31 462.14C1511.31 399.28 1552.3 394.27 1552.3 394.27",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1779.92 337.63C1828.67 287.6 1828.55 232.28 1811.3 198.51C1793.59 163.83 1742.21 149.44 1710.86 123.58C1656.3 78.5699 1666.29 -26.2501 1576.83 7.60994C1478.81 44.7099 1478.08 223.98 1518.86 298.1C1573.91 398.16 1742.82 375.71 1779.92 337.63V337.63Z",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1657.6 376.38C1657.6 287.14 1599.41 280.03 1599.41 280.03",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1657.6 514.31V351.77",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1657.6 376.38C1657.6 287.14 1715.79 280.03 1715.79 280.03",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1460.09 404.91C1460.09 464.68 1445.34 483.38 1427.14 483.38C1408.94 483.38 1394.19 464.68 1394.19 404.91C1394.19 345.14 1408.94 266.95 1427.14 266.95C1445.34 266.95 1460.09 345.15 1460.09 404.91V404.91Z",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1427.14 483.37V512.56",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1494.33 513.91C1494.33 513.91 1488.86 496.99 1498.67 486.32C1512.18 471.63 1524.82 485.78 1537.58 481.05C1550.73 476.17 1560.26 452.25 1585.21 461.17C1619.67 473.5 1610.77 513.91 1610.77 513.91H1494.34H1494.33Z",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1518.86 298.11C1497.18 258.7 1487.23 189.55 1497.41 127.86C1484.52 131.81 1472.19 137.47 1461.11 144.66C1380.51 196.95 1350.21 266.04 1399.22 338.94C1405.05 299.66 1415.37 266.95 1427.14 266.95C1444.06 266.95 1458 334.58 1459.87 392.12C1507.62 413.29 1564.78 403.66 1603.33 361.45C1568.55 351.41 1537.31 331.66 1518.86 298.12V298.11Z",
    fill: "#091731",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 514.31H1890",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 514H1890",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4_516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 514H584.64",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.51 514.12C289.95 514.12 313.2 489.43 326.44 489.43C339.68 489.43 363.48 514.12 377.27 514.12",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.23 488.57V472.08",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.76 465.86C335.84 471.78 326.53 472.08 326.53 472.08C326.53 472.08 326.83 462.78 332.75 456.85C338.67 450.93 347.98 450.63 347.98 450.63C347.98 450.63 347.68 459.93 341.76 465.86Z",
    fill: "#091731",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.59 465.86C316.51 471.78 325.82 472.08 325.82 472.08C325.82 472.08 325.52 462.78 319.6 456.85C313.68 450.92 304.37 450.63 304.37 450.63C304.37 450.63 304.67 459.93 310.59 465.86Z",
    fill: "#091731",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.68 469.67C458.68 466.31 407.08 469.56 404.18 471.06C400.29 473.07 400.38 482.39 402.17 493.84C403.96 505.29 404.67 514.13 410.39 514.13H455.46C459.95 514.13 458.68 473.03 458.68 469.67V469.67Z",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.13 479.09C484.1 484.38 490.65 489.46 493.43 485.11C494.56 483.33 491.74 477.04 486.62 471.57C482.74 467.42 474.87 462.64 473.35 464.98C471.83 467.32 472.86 472.43 479.13 479.09Z",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.35 510.65L480.82 480.99",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.4 500.25L476.79 477.01",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.98 479.77C396.81 480.44 384.97 480.45 384.63 491.16C384.29 501.87 402.92 498.85 402.92 498.85",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.96 514.12C138.81 510.27 145.32 497.6 151.67 496.97",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.61 467.78L96.9301 513.41C105.24 517.4 124.97 503.84 135.95 495.91C144.93 489.43 159.71 494.25 159.71 494.25",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.7 494.25C159.7 494.25 154.97 492.71 149.24 492.54C149.03 504.67 150.74 513.99 153.49 514.12C156.5 514.26 159.59 503.31 160.25 489.52C160.41 486.13 160.44 483.53 160.32 480.57",
    fill: "#091731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.7 494.25C159.7 494.25 154.97 492.71 149.24 492.54C149.03 504.67 150.74 513.99 153.49 514.12C156.5 514.26 159.59 503.31 160.25 489.52C160.41 486.13 160.44 483.53 160.32 480.57",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.77 422L188.26 430.97",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.84 489.43C172.98 479.3 130.51 488.03 116.26 449.28C107.49 425.44 135.67 398.16 148.65 387.18",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.2 446.81C209.38 440.2 192.89 433.22 171.82 425.97C161.65 422.47 151.67 419.37 151.67 419.37",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.49 514.12C153.49 514.12 181.77 514.12 204.96 514.12C232.8 514.12 247.31 516.11 259.32 501C264.11 494.97 267.62 484.32 255.62 470.58",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.37 351.16C274.37 365.74 273.3 377.59 272.37 398.87C272.37 398.87 266.57 400.87 256.92 400.87C247.27 400.87 239.33 398.54 239.33 398.54L240.69 386.9",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.2 409.65C237.1 392.01 251.68 372.64 251.68 372.64",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.3 334.52C271.3 334.52 278.11 347.75 284.41 347.56C293.02 347.3 303.32 334.69 304.77 321.45C306.21 308.21 295.51 299.67 286.91 298.64C275.8 297.3 272.61 315.62 268.54 321.86C264.47 328.1 258.32 327.96 253.36 327.54C231.03 325.64 221.04 327.34 204.65 333.21C189.22 338.74 163.98 364.33 143.19 384.25C163.64 394.56 187.92 415.84 203.74 429.94C205.49 428.24 207.35 426.33 209.29 424.26",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.29 297.2C306.42 280.25 286.97 261.18 266.19 267.69C243.46 274.81 252.58 296.79 252.58 296.79C252.58 296.79 235.92 296.13 234.88 305.88C233.84 315.64 249.17 318.48 249.17 318.48C249.17 318.48 242.81 321.57 246.37 327.02C248.56 327.14 250.88 327.3 253.35 327.52C258.31 327.94 264.46 328.08 268.53 321.84C272.6 315.6 275.79 297.29 286.9 298.62C295.5 299.65 306.2 308.19 304.76 321.43C303.74 330.79 298.3 339.83 292.15 344.42C294.92 352 305.31 348.79 303.65 339.7C318.12 345.04 319.32 324.64 315.5 321.25C326.4 308.25 317.95 289.89 303.28 297.19L303.29 297.2Z",
    fill: "#091731",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.18 320.99C261.85 322.5 258.23 330.13 266.69 324.19C270.19 321.73 273.08 311.46 277.8 311.75C282.44 312.04 277.55 321.47 283.63 323.52C290.33 325.78 305.82 319.9 308.11 315.8C305.44 309.36 294.44 296.57 283.42 294.39C267.38 291.21 247.13 316.44 258.19 320.99H258.18Z",
    fill: "#091731",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.73 327.63C251.67 334.37 254.17 368.17 266.37 351.16C269.28 347.1 274.78 340.14 274.78 340.14",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.61 380.6C199.81 359.79 202.22 337.82 212.71 330.51",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.08 346.9L231.79 383.27",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.45 400.86C245.45 400.86 246.54 427.05 248.78 432.25C252.55 441.01 268.43 466.72 276.7 470.8C283.03 473.93 292.56 479.75 296.67 482.11C299.68 483.84 303.32 495.82 306.65 494.08C310.53 492.06 304.69 480.33 302.44 477C300.19 473.67 288.69 466.43 285.37 464.36C282.05 462.29 269.08 433.58 266.42 427.6C263.76 421.61 266.25 400.2 266.25 400.2",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.91 378.84C203.91 378.84 202.06 405.27 203.72 410.68C206.51 419.79 219.51 447.08 227.28 452.04C233.24 455.84 242.07 462.66 245.9 465.45C248.71 467.5 251.02 479.8 254.52 478.43C258.59 476.84 254.07 464.55 252.19 461C250.31 457.45 239.68 449 236.6 446.57C233.52 444.15 223.75 414.2 221.75 407.97C219.75 401.74 224.56 380.37 224.56 380.37",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.53 380.36C221.68 379.81 218.2 379.35 214.41 379.06C210.5 378.76 206.88 378.7 203.94 378.83",
    fill: "#091731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.53 380.36C221.68 379.81 218.2 379.35 214.41 379.06C210.5 378.76 206.88 378.7 203.94 378.83",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.59 385.07C228.45 384.92 231.71 384.28 231.79 383.27C231.86 382.3 229 381.23 224.56 380.37C224.56 380.39 224.13 382.27 223.59 385.07Z",
    fill: "#091731",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.91 378.84C199.56 379.04 196.68 379.66 196.61 380.6C196.54 381.55 199.31 382.6 203.62 383.45C203.78 380.68 203.9 378.85 203.91 378.83V378.84Z",
    fill: "#091731",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.74 429.93L190.89 427.35L194.52 422.35L203.74 429.93Z",
    fill: "#091731",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.19 384.24L145.89 389.56L148.58 387.25L143.19 384.24Z",
    fill: "#091731",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.83 129.2H90.84C96.31 94.89 123.36 82.1501 129.18 101.47C149.02 49.07 215.47 37.3601 221.23 75.16C249.17 53 268.07 83.38 251.64 100.64C286.98 98.17 267.83 129.2 267.83 129.2Z",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.58 203.8C347.74 185.07 371.03 165.2 381.31 182.71C412.94 143.37 445.15 186.8 436.37 203.8H346.58Z",
    stroke: "#091731",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 607.11,
    height: 515.31,
    fill: "white",
    transform: "translate(1280)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4_516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 584.64,
    height: 463.22,
    fill: "white",
    transform: "translate(1 52)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeedlingTrees);
export default __webpack_public_path__ + "static/media/Seedling_Trees.93ad320e7a109ac7a58579586e0c43ae.svg";
export { ForwardRef as ReactComponent };